



































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import RoleRequestProcess from "@/models/security/roleRequestProcess.model";
import RoleRequest from "../../models/security/roleRequest.model";
import RoleRequestService from "@/services/roleRequest.model";
import UserService from "@/services/user.service";
import { Utils } from "@/core/Utils";
import { IdentificationType } from "@/enums/IdentificationType";
import { Sex } from "../../enums/Sex";
import { UserType } from "@/enums/UserType";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";
import User from "../../models/security/user.model";
import moment from 'moment';

@Component({
  components: { DatePickerComponent, BaseSelectResearchCenter },
})
export default class RoleRequestComponent extends BaseVue {
  isModalRequestRole = false;

  userTypeChoosed = null;
  UserType = UserType;
  isInvestigator = false;
  model: RoleRequestProcess = new RoleRequestProcess();
  roleRequestService: RoleRequestService = new RoleRequestService();
  userService: UserService = new UserService();
  loadingSave = false;
  loading = false;
  updatedUser: User = null;
  messageError = '';
  institutionsId = null;
dOBError = '';
dateOB = null;
isRoleRequestActive = false;
cleanError(){
  this.messageError ='';

  
}
@Watch("model.user.identificationType")
  onIdentificationTypeChange(){
    if(this.model.user.identificationType == 1){
      this.messageError = '';
    }
  }

@Watch("model.user.dob")
  validateDob(){
    if(this.isRoleRequestActive){
    var actDate = new Date();
            var dob = moment(this.model.user.dob, "YYYY-MM-DD");
            var actualDate = moment(actDate, "YYYY-MM-DD");
       var value = moment.duration(dob.diff(actualDate)).asYears();
       
      let number = Math.abs(Math.ceil(value));
      if(number < 18){
        this.$buefy.toast.open({
        message: "Debes ser mayor de edad para completar esta solicitud de rol",
        queue: false,
        duration: 4000,
        type: "is-danger",
        position: "is-top-right",
      });
          this.dOBError = 'Debes ser mayor de edad para completar esta solicitud de rol'
       }else{
         this.dOBError = '';
       }
    }
    }
  validateIdenticaction(event: any) {
    let c = event.target.value.split("");
    let v = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
    var result = 0;
    var ar;
    let result1 = "";
    var up;
    var oc;
    for (var i = 0; i < 10; i++) {
      up = c[i] * v[i];
      let ab = up;
      if (ab >= 10) {
        oc = ab
          .toString()
          .split("")
          .map((x) => parseInt(x))
          .reduce((x, y) => x + y);
      } else {
        oc = ab;
      }
      result = result + parseFloat(oc);
    }

    let dp = result;
    var ac1 = dp.toString().split("")[0] + "0";
    let ac = parseInt(ac1);
    let uj = (ac / 10) * 10;
    if (uj < dp) {
      dp = uj + 10 - dp;
    }

    if (c[10] == dp) {
     
    } else {
      this.$buefy.toast.open({
        message: "La Cédula es incorrecta",
        queue: false,
        duration: 4000,
        type: "is-danger",
        position: "is-top-right",
      });
     this.messageError = 'Favor introducir una Cédula validada';

    }
  }

  get isLoading() {
    return this.$store.state.loading;
  }
  @Watch("$store.state.openAddRequesRoleModal")
  @Watch("isModalRequestRole")
  async onOpenAddRequesRoleModal(value: boolean) {
    this.isRoleRequestActive = value;
    if (value) {
      this.updatedUser = null;
      this.$store.commit("set_refreshUserLoading", true);
      let user = await this.userService.getSimpleUserById(this.user.id);
      this.setCurrentUser(user);
      //this.updateCurrentUser(user);

      //localStorage.removeItem("user");
      //sessionStorage.setItem("user", JSON.stringify(this.model.user));
    
      this.$store.commit("set_refreshUserLoading", false);
    }
    this.isModalRequestRole = value;
  }

  updateCurrentUser(user) {
    this.model.user.id = user.id;
    this.model.user.dob = new Date(user.dob);
    this.model.user.name = user.name;
    this.model.user.lastName = user.lastName;
    this.model.user.academicTitleId = user.academicTitleId;
    this.model.user.academicAreaId = user.academicAreaId;
    this.model.user.identification = user.identification;
    this.model.user.sex = user.sex;
    this.model.user.identificationType = user.identificationType;
    this.model.user.countryId = user.countryId;
    this.validateIdenfication();
    this.validateContry();
  }

  @Watch("updatedUser")
  onUpdatedUserChange(value: User) {
    if (value) {
      this.model.user.sex = value.sex;
    }
  }

  chooseUserType(userType: any) {
    this.userTypeChoosed = userType;
  }

  addRoleRequest() {
    this.model.roleRequests.push(new RoleRequest());
  }

  removeRoleRequest(index: any) {
    this.model.roleRequests.splice(index, 1);
  }

  get user() {
    return this.$store.state.user;
  }

  onModalClose() {
    this.userTypeChoosed = null;
    this.$store.commit("setOpenAddRequesRoleModal", false);
  }
  detroyed() {
    this.userTypeChoosed = null;
    this.$store.commit("setOpenAddRequesRoleModal", false);
  }

  async complete() {
    try {
      var result = await this.$validator.validateAll();
      if(this.dOBError){
          this.validateDob();
          return;
      }
      if(this.messageError || !this.model.user.identification){
            this.$buefy.toast.open({
        message: "La Cédula es incorrecta",
        queue: false,
        duration: 4000,
        type: "is-danger",
        position: "is-top-right",
      });
        return;
      }
      if (result) {
        for (let i = 0; i < this.model.roleRequests.length; i++) {
          const request = this.model.roleRequests[i];
          request.userType = this.userTypeChoosed;
        }
        this.model.user.permissions = [];
        this.model.user.roles = [];

        if (this.userTypeChoosed == UserType.FONDOCYTUSER) {
          var roleR = this.model.roleRequests[0];
          roleR.researchCenterId = null;

          this.model.roleRequests = [];
          this.model.roleRequests.push(roleR);
        } else if (this.userTypeChoosed == UserType.ADMINRESEARCHCENTER) {
          var roleR = this.model.roleRequests[0];
          this.model.roleRequests = [];
          this.model.roleRequests.push(roleR);
        }
        
        this.loadingSave = true;
        this.roleRequestService
          .generateRequest(this.model)
          .then((response:any) => {
           
              this.isModalRequestRole = false;
              
            
            this.operationSuccess(
              "Su solicitud ha sido enviada, favor espere respuesta!",
              6000
            );
            this.$store.commit("setOpenAddRequesRoleModal", false);
            this.$store.commit("setUpdateRequestRoleTable", true);
            this.model.roleRequests = [];
            this.addRoleRequest();
            this.userTypeChoosed = null;
          })
          .finally(() => {
            this.loadingSave = false;
          });
        return;
      }

      throw this.$validator.errors.items.map((e) => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }

  hasAny() {
    if (this.user.id) {
      this.roleRequestService.hasAnyRequest(this.user.id).then((exist) => {
        if (!this.user.isAdmin) {
          this.isModalRequestRole = !exist;
        }
      });
    }
  }
  @Watch("user.id")
  onUser(id: any) {
    if (id) {
      this.hasAny();
    }
  }
  @Watch("$store.state.defaultCountry")
  onDefaultCountry(country: any) {
    if (!this.model.user.countryId && this.$store.state.defaultCountry) {
      this.model.user.countryId = this.$store.state.defaultCountry.id;
    }
  }

  mounted() {
    this.hasAny();
    this.model.roleRequests = [];
    this.addRoleRequest();
    this.setCurrentUser(this.user);
  }

  setCurrentUser(user: User) {
    Utils.mapToObject(user, this.model.user);
    this.validateIdenfication();
    this.validateContry();
  }

  validateIdenfication() {
    if (!this.model.user.identificationType) {
      this.model.user.identificationType =
        IdentificationType.IDENTIFICATIONCARD;
    }
  }
  validateContry() {
    if (!this.model.user.countryId && this.$store.state.defaultCountry) {
      this.model.user.countryId = this.$store.state.defaultCountry.id;
    }
  }
}
